var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldAlt1Check(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36754 4.51442L11.3675 2.10594C11.7781 1.96469 12.2219 1.96469 12.6325 2.10594L19.6325 4.51442C20.4491 4.79542 21 5.58431 21 6.47289V13.9608C21 15.7588 20.0935 17.4271 18.6073 18.3646L13.5643 21.5457C12.604 22.1514 11.396 22.1514 10.4356 21.5457L5.39275 18.3646C3.90648 17.4271 3 15.7588 3 13.9608V6.47289C3 5.58431 3.55086 4.79542 4.36754 4.51442ZM17.5303 9.66118C17.8232 9.35886 17.8232 8.86869 17.5303 8.56636C17.2374 8.26404 16.7626 8.26404 16.4697 8.56636L11 14.2122L8.53033 11.663C8.23744 11.3607 7.76256 11.3607 7.46967 11.663C7.17678 11.9653 7.17678 12.4555 7.46967 12.7578L10.4697 15.8544C10.7626 16.1567 11.2374 16.1567 11.5303 15.8544L17.5303 9.66118Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt1Check);
export default __webpack_public_path__ + "static/media/shield-alt-1-check.07d8468de21cbc046a987faadfa21fbd.svg";
export { ForwardRef as ReactComponent };